import { Injectable } from '@angular/core';
import { AuthConfig } from '@michelin/auth';
import { environment } from '../../../environments/environment';

export interface EnvConfiguration {
  ENVIRONMENT: string;
  KEYCLOAK_ISSUER: string;
  KEYCLOAK_CLIENTID: string;
  KEYCLOAK_SECRET: string;
  ENDPOINT_TOKEN: string;
  oauth2_scopes: string;
  REDIRECT_URI: string;
  KEYCLOAK_LOGOUT_REDIRECT: string;
  BACKEND_URL: string;
  BACKEND_SUB_PATH: string;
}

interface CustomWindow extends Window {
  __APP_CONFIG__?: Partial<EnvConfiguration>;   // Config.json (ConfigMap)
  __APP_SECRETS__?: Partial<EnvConfiguration>;  // Secrets (K8s env vars)
}

@Injectable({ providedIn: 'root' })
export class EnvConfigurationService {
  /**
   * Loads dynamic configuration from:
   * 1. window.__APP_CONFIG__ (assets/config.json <- K8s ConfigMap)
   * 2. window.__APP_SECRETS__ (assets/env-secrets.js <- K8s Secret via initContainer)
   */
  public static loadDynamicConf(): void {
    const runtimeConfig = (window as CustomWindow).__APP_CONFIG__ || {};
    const runtimeSecrets = (window as CustomWindow).__APP_SECRETS__ || {};

    EnvConfigurationService.configuration = {
      ...EnvConfigurationService.configuration,
      ...runtimeConfig,   // ConfigMap (non-sensitive)
      ...runtimeSecrets   // Secrets (sensitive) - overrides last
    };
  }

  // Configuration loaded from environment.ts (or environment.prod.ts in production)
  // Can be overridden by assets/config.json (K8s ConfigMap) via window.__APP_CONFIG__
  public static configuration: EnvConfiguration = environment.config;
  /**
   * Provider configuration for authent lib reusable.
   *
   * @returns Configuration for authent lib
   */
  public static getAuthConfigEnv(): AuthConfig {
    return {
      authOnAppInitializer: true,
      issuer: EnvConfigurationService.configuration.KEYCLOAK_ISSUER,
      clientId: EnvConfigurationService.configuration.KEYCLOAK_CLIENTID,
      clientSecret: EnvConfigurationService.configuration.KEYCLOAK_SECRET,
      tokenEndpoint: EnvConfigurationService.configuration.ENDPOINT_TOKEN,
      redirectUri: EnvConfigurationService.configuration.REDIRECT_URI,
      postLogoutRedirectUri: EnvConfigurationService.configuration.KEYCLOAK_LOGOUT_REDIRECT,
      bearerAllowedUrls: [EnvConfigurationService.configuration.BACKEND_URL],
      sessionChecksEnabled: false
    };
  }
  public static getEnv(): string {
    return EnvConfigurationService.configuration.ENVIRONMENT;
  }
}

EnvConfigurationService.loadDynamicConf();
